"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnlineSubscription = exports.isOnline = void 0;
const online_status_subscription_1 = require("./online-status-subscription");
const browser_online_status_subscription_1 = require("../browser-online-status-subscription");
// KP note 2022-12-20: backwards compatibility helpers to minimize code updates requirements
/**
 * @deprecated Use 'getOnlineStatusSubscription().isOnline' instead to get current status
 */
exports.isOnline = () => online_status_subscription_1.getOnlineStatusRequest(10000);
/**
 * @deprecated Use 'getOnlineStatusSubscription()' instead
 */
exports.isOnlineSubscription = () => browser_online_status_subscription_1.getOnlineStatusSubscription();
